"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_HEIGHT = exports.DEFAULT_UNIT = exports.UNITS = void 0;
/**
 * @internal
 */
exports.UNITS = ["px", "%", "rem", "em"];
/**
 * @internal
 */
exports.DEFAULT_UNIT = "px";
/**
 * @internal
 */
exports.DEFAULT_HEIGHT = {
    px: "400",
    "%": "50",
    rem: "25",
    em: "25",
};
//# sourceMappingURL=types.js.map